export function compactReminderNotifications(items, now = Date.now()) {
  const groups = new Map();
  return items.reduce((result, item) => {
    if (!['booking_reminder_2h','booking_reminder_24h'].includes(item.type) || !item.bookingId || !item.businessId) {result.push(item); return result;}
    const expiresAt = Number(item.data?.expiresAtMs || item.data?.data?.expiresAtMs || 0);
    const entry = expiresAt > 0 && expiresAt <= now ? {...item, title:'Recordatorio de cita pasada', expired:true} : {...item};
    const occurrence = item.data?.occurrenceKey || item.body;
    const key = [item.businessId,item.bookingId,item.type,occurrence].join('|');
    if (groups.has(key)) {const prior=groups.get(key); prior.read=prior.read || entry.read; prior.duplicateItems.push(item);}
    else {entry.duplicateItems=[item];groups.set(key,entry);result.push(entry);}
    return result;
  },[]);
}
